
import { Component, Vue } from 'vue-property-decorator';
import MainHeader from '@/components/main-header.vue';
import BatchPrinting from '@/components/batch-printing.vue';
import AiWen from '@/components/template-transfer-pc/template/components/special/ai-wen.vue';
@Component({
    components: {
        MainHeader,
        BatchPrinting,
        AiWen,
    },
})
export default class EditWen extends Vue {
    private ifShowBatchPrinting: boolean = false;
    private selectedIds: any = [];
    private get patient() {
        return this.$store.state.patient;
    }
    private prev() {
        (this.$refs.aiWen as any).prev();
    }
    private goPrint(ids: any) {
        this.selectedIds = ids;
        this.ifShowBatchPrinting = true;
    }

    private save(data: any) {
        this.$router.back();
    }

}
